'use client';

import { useEffect } from 'react';
import { captureAttribution } from '@/utils/attribution';

/**
 * Montado uma vez no layout (todas as páginas) — grava a campanha de
 * anúncios (UTM, gclid, fbclid) do URL com que o cliente chegou, para o
 * checkout a conseguir reenviar mais tarde. Não usa `useSearchParams` (não
 * precisa de Suspense): lê `window.location.search` diretamente, já que só
 * corre no browser.
 */
const AttributionCapture = () => {
  useEffect(() => {
    captureAttribution();
  }, []);

  return null;
};

export default AttributionCapture;
